import { ApplicationRef, ComponentRef, inject, Injectable, Type, createComponent, EnvironmentInjector } from '@angular/core';
import { Case } from '../../../../core/models';
import { Observable } from 'rxjs';
import { CaseStatusDialogComponent } from './case-status-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class CaseStatusDialogService {
  private appRef = inject(ApplicationRef);
  private injector = inject(EnvironmentInjector);
  private dialogRef: ComponentRef<CaseStatusDialogComponent> | null = null;

  open(caseDetails$: Observable<Case | null>): void {
    if (this.dialogRef) {
      this.close();
    }

    this.dialogRef = createComponent(CaseStatusDialogComponent, {
      environmentInjector: this.injector,
    });

    this.dialogRef.instance.caseDetails$ = caseDetails$;
    this.dialogRef.instance.close = () => this.close();

    this.appRef.attachView(this.dialogRef.hostView);
    document.body.appendChild(this.dialogRef.location.nativeElement);
  }

  close(): void {
    if (this.dialogRef) {
      this.appRef.detachView(this.dialogRef.hostView);
      this.dialogRef.destroy();
      this.dialogRef = null;
    }
  }
}
